/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-root-reducer.js to modify the generation of this file.
import { combineReducers } from 'redux'
import checkoutReducer from '../../src/Feature/hedin-checkout/reducers/checkoutReducer';
import filterReducer from '../../src/Feature/hedin-filters/reducers/filterReducer';

export default combineReducers({
	  checkout: checkoutReducer,
  filter: filterReducer,
})
